
// export const myGetter = ( state ) => {
//  return state
// }

export const unitsList = state => state.units
export const unitsSelectable = state => state.unitsSelectable
export const unitsPaginatedData = state => state.unitsPaginatedData
export const unit = state => state.unit
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData